import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-consultoria-de-lactancia',
  templateUrl: './subpage-consultoria-de-lactancia.component.html',
  styleUrls: ['./subpage-consultoria-de-lactancia.component.scss']
})
export class SubpageConsultoriaDeLactanciaComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
